import { render, staticRenderFns } from "./ShowStats.vue?vue&type=template&id=c2aa5bfc"
import script from "./ShowStats.vue?vue&type=script&lang=js"
export * from "./ShowStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports